<div class="info-popup__header">
  <h2 mat-dialog-title class="info-popup__title">{{ data.title }}</h2>
  <button type="button" class="info-popup__close" mat-dialog-close [attr.aria-label]="'label.Close' | translate">
    <svg-icon src="/assets/icons/dialog-close.svg" aria-hidden="true"></svg-icon>
  </button>
</div>

<!-- focusable so keyboard users can scroll the long legal text -->
<mat-dialog-content class="info-popup__body" tabindex="0">
  <div class="info-popup__text" [innerHtml]="data.text | safeHtml"></div>
</mat-dialog-content>

<mat-dialog-actions class="info-popup__actions">
  <button type="button" class="info-popup__agree" [mat-dialog-close]="true">{{ 'label.Agree' | translate }}</button>
</mat-dialog-actions>
